import axios from 'axios';

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Add a request interceptor to add the token to every request
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle session expiration (401 Unauthorized)
    // BUT: Don't redirect if we're already on the login page (login failures should show error messages)
    // AND: Don't redirect if the request was to the login endpoint (let the Login component handle it)
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/api/auth/login');
      const isOnLoginPage = window.location.pathname.includes('/login');
      
      // Only redirect if it's NOT a login request and NOT already on login page
      // This allows login errors (like pending account) to be displayed properly
      if (!isLoginRequest && !isOnLoginPage) {
        console.log('Session expired - redirecting to login');
        
        // Clear user data from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Redirect to login page
        window.location.href = '/login?expired=true';
        
        return Promise.reject(new Error('Session expired. Please log in again.'));
      }
    }
    
    return Promise.reject(error);
  }
);

// Override the default axios export to use our configured instance
// This makes all imports of 'axios' use our configured instance with interceptors
Object.assign(axios, axiosInstance);
axios.create = () => axiosInstance;

export default axiosInstance; 